import React from 'react';
import { Table } from 'UI';
import SectionBasePage from 'components/SectionBasePage';
import { useBreadcrumbNavigation } from 'hooks/breadcrumb';
import { useRouteMatch } from 'react-router';
import { ROUTES } from 'constants/routes';

import {
  MainContainer,
  ProcessTable,
  ActionButton,
} from './style';

const RootPage = (): JSX.Element => {
  const breadcrumbNavigator = useBreadcrumbNavigation();
  const { url } = useRouteMatch();
  const structuresSections = [
    {
      key: 'germination',
      title: 'Câmaras de germinação',
      route: ROUTES.dashboard.infrastructure.germinationRoom.root,
    },
    {
      key: 'healing',
      title: 'Salas de cicatrização',
      route: ROUTES.dashboard.infrastructure.healingRoom.root,
    },
    {
      key: 'greenhouse',
      title: 'Estufas',
      route: ROUTES.dashboard.infrastructure.greenhouse.root,
    },
    {
      key: 'vehicle',
      title: 'Veículos',
      route: ROUTES.dashboard.infrastructure.vehicle.root,
    },
  ];

  const processSections = [
    {
      key: 'seeding',
      title: 'Semeio',
      route: ROUTES.dashboard.infrastructure.tray.root,
    },
  ];

  return (
    <SectionBasePage>
      <MainContainer>
        <Table
          dataSource={structuresSections}
          pagination={false}
        >
          <Table.Column
            title="Estruturas"
            key="structures"
            dataIndex="title"
          />
          <Table.Column
            title=""
            dataIndex="route"
            width="150px"
            render={(route, record: { title: string }) => (
              <ActionButton onClick={() => breadcrumbNavigator.push({
                label: `${record.title}`,
                url: `${url}${route}`,
              })}
              >
                ver detalhes »
              </ActionButton>
            )}
          />
        </Table>

        <ProcessTable
          dataSource={processSections}
          pagination={false}
        >
          <Table.Column
            title="Processos"
            key="process"
            dataIndex="title"
          />
          <Table.Column
            title=""
            dataIndex="route"
            width="150px"
            render={(route, record: { title: string }) => (
              <ActionButton onClick={() => breadcrumbNavigator.push({
                label: `${record.title}`,
                url: `${url}${route}`,
              })}
              >
                ver detalhes »
              </ActionButton>
            )}
          />
        </ProcessTable>
      </MainContainer>
    </SectionBasePage>
  );
};

export default RootPage;
